import { render, staticRenderFns } from "./CreateSync.vue?vue&type=template&id=084bd59b"
import script from "./CreateSync.vue?vue&type=script&lang=ts"
export * from "./CreateSync.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports